import QuestionGenerator from '@Molecule/QuestionGenerator'
import Styles from './style.module.scss'
import Button from '@Atom/Button'
import { makeRandomString } from '@Helpers/makeRandomString'

export default function QuestionsSection({
  questions,
  setQuestions = () => { }
}) {

  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <h3>Bank Soal</h3>
        <span>Buat dan tambahkan soal sebagai test akhir pada pembelajaran kelas yang telah dilaksanakan.</span>
      </div>
      <div className={Styles.content}>
        <div className={Styles.questions}>
          {
            questions?.map((q, qI) => (
              <QuestionGenerator
                key={qI}
                placeholderRadio={'Masukkan opsi jawaban'}
                question={`Soal ${qI + 1}`}
                valueTextEditor={q?.question}
                setValueTextEditor={(newVal) => {
                  const newQuestions = questions?.map(obj => {
                    if (obj?.id === q?.id) {
                      return {
                        ...obj,
                        question: newVal
                      }
                    } return obj
                  })
                  setQuestions(newQuestions)
                }}
                withDeleteOption={qI !== 0}
                onDelete={() => setQuestions(prev => prev?.filter(obj => obj?.id !== q?.id))}
                options={q?.options}
                setOptions={(newOptions) => {
                  const newQuestions = questions?.map(obj => {
                    if (q?.id === obj?.id) {
                      return {
                        ...obj,
                        options: newOptions
                      }
                    } return obj
                  })
                  setQuestions(newQuestions)
                }}
              />

            ))
          }
        </div>
        <Button
          text={'Tambah Soal'}
          variant='outlined'
          startIcon={'plus'}
          iconSize={'11px'}
          onClick={() => {
            const newQuestions = [...questions, {
              id: makeRandomString(5),
              type: 'PILIHAN GANDA',
              question: '',
              options: [
                {
                  id: 1,
                  option: '',
                  isCorrect: true
                },
                {
                  id: 2,
                  option: '',
                  isCorrect: false
                },
                {
                  id: 3,
                  option: '',
                  isCorrect: false
                },
                {
                  id: 4,
                  option: '',
                  isCorrect: false
                },
              ]
            },]
            setQuestions(newQuestions)
          }}
        />
      </div>
    </div>
  )
}